import React from 'react'
import { Divider, Separator, H3 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import LangList from './LangList'
import { getLangDisplayForCodes } from './langFunctions'

export default function RecentLangList({ recentLangs = [], ...localeProps }) {
  const { t } = useTranslation()
  const recentLanguages = useFeatureFlag('home_footer_recentLanguages')

  if (!recentLanguages.isOn) return null

  const langListProps = {
    orderedLangs: getLangDisplayForCodes(recentLangs),
    fieldName: 'recentLocales',
    orientation: 'horizontal',
    ...localeProps,
  }

  return (
    <>
      <H3 size="H6" supplementary>
        {t('lang-picker.recent-languages.title', 'Recently used languages')}
      </H3>
      <Separator size="nano" />
      <LangList {...langListProps} />
      <Separator />
      <Divider />
      <Separator />
    </>
  )
}
